import { Component, Input, OnInit, ViewChild, inject } from '@angular/core';
import { BaseComponent, WmsToggleComponent } from '@wms/app/components';
import { CommonModule } from '@angular/common';
import { FormsModule, NgForm } from '@angular/forms';
import { DB_PROVIDER, DatabaseComponent, OPENID_PROVIDER, SecurityService } from '@wms/settings/security';
import { find, includes, isArray, isEqual } from 'lodash-es';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { Subscription } from 'rxjs';

@Component({
  standalone: true,
  selector: 'wms-open-id',
  templateUrl: './open-id.component.html',
  styleUrls: ['./open-id.component.less'],
  imports: [CommonModule, FormsModule, TooltipModule, WmsToggleComponent, DatabaseComponent]
})
export class OpenIdComponent extends BaseComponent implements OnInit {
  @Input() securityProps: any;
  @Input() authInfo: any;
  security: any;
  securityService: SecurityService;
  formChangesSubscription: Subscription;
  resetFormSubscription: Subscription;
  updateOpenIdProviderIdSubscription: Subscription;
  @ViewChild('openIdForm', { static: true }) ngForm: NgForm;

  constructor() {
    super();
    this.securityService = inject(SecurityService);
  }

  ngOnInit(): void {
    this.security = this.securityService.security;
    this.security.openIdRoleProviders = [OPENID_PROVIDER, DB_PROVIDER];

    if (this.security.enableSecurity) {
      //hiding error messages if any, since provider was changed
      // TODO - needed?
      // this.hideMessage = true;
    }
    this.security.showUnamePass = false;
    this.securityService.getOpenIdOptions(this.authInfo);
    let setInitialValue: boolean = true;
    if (this.securityService.openIdInitalValue) {
      setInitialValue = false;
      setTimeout(() => {
        this.ngForm.form.patchValue(this.securityService.openIdInitalValue);
      });
    }

    this.formChangesSubscription = this.ngForm.form.valueChanges.subscribe(val => {
      if (!this.ngForm.form.dirty && setInitialValue) {
        this.securityService.openIdInitalValue = this.ngForm.form.value;
      }
      if (this.ngForm.form.dirty) {
        if (isEqual(this.securityService.openIdInitalValue, this.ngForm.form.value)) {
          this.security.dirtyCheckList.splice(this.security.dirtyCheckList.indexOf('openidProvider', 1));
        } else if (!includes(this.security.dirtyCheckList, 'openidProvider')) {
          this.security.dirtyCheckList.push('openidProvider');
        }
      }
    });


    this.resetFormSubscription = this.securityService.resetForm.subscribe((resetInitialVal) => {
      if (!resetInitialVal) {
        this.ngForm.form.reset(this.securityService.openIdInitalValue);
      } else {
        this.securityService.openIdInitalValue = this.ngForm.form.value;
      }
    });
    this.updateOpenIdProviderIdSubscription = this.securityService.getUpdateOpenIdProviderId().subscribe((value)=>{
      this.updateOpenIdOptions(value);
    })
  }

  copyToClipboard($event: any) {
    let $temp = $($event.target).closest('.input-group').find('input');
    $temp.select();
    document.execCommand('copy');
  }

  // sets the default provider options when the provider is changed.
  updateOpenIdOptions(selectedProvider: string) {
    let selectedProviderOptions;

    // in case of custom reset default values.
    if (selectedProvider === 'custom') {
      this.securityService.resetOpenIdConfig();
      this.securityService.resetRoleMappingConfig();
    } else {
      selectedProviderOptions = find(this.securityService.providers, { providerId: selectedProvider });
      // if the selected provider is in default providers list then update the opendId props.
      if (selectedProviderOptions) {
        if(this.securityService.isOpenIdProviderDisabled) this.security.enableSecurityProvider = selectedProviderOptions.enabled;
        this.security.providerId = selectedProviderOptions.providerId;
        this.security.clientId = selectedProviderOptions.clientId;
        this.security.clientSecret = selectedProviderOptions.clientSecret;
        this.security.authorizationUrl = selectedProviderOptions.authorizationUrl;
        this.security.tokenUrl = selectedProviderOptions.tokenUrl;
        this.security.jwkSetUrl = selectedProviderOptions.jwkSetUrl;
        this.security.userInfoUrl = selectedProviderOptions.userInfoUrl;
        this.security.logoutUrl = selectedProviderOptions.logoutUrl;
        this.security.scopes = isArray(selectedProviderOptions.scopes) ? selectedProviderOptions.scopes.join(', ') : selectedProviderOptions.scopes;
        this.security.userNameAttributeName = selectedProviderOptions.userNameAttributeName;
        this.securityService.toggleRoleMapping(selectedProviderOptions.roleMappingEnabled);
        if (selectedProviderOptions.roleMappingEnabled) {
          let roleMappingOptions = selectedProviderOptions.roleMappingConfig;
          if (!roleMappingOptions.modelName) {
            this.security.roleProvider = OPENID_PROVIDER.id;
            this.security.roleAttributeName = roleMappingOptions.roleAttributeName;
          } else {
            this.security.roleProvider = DB_PROVIDER.id;
            this.securityService.setDBConfiguration(roleMappingOptions)
          }
        }
      }
    }
    // update the redirect url when provider is changed.
    this.securityService.changeRedirectUrlURL();
    this.securityService.openIdInitalValue = this.ngForm.form.value;
    if (isEqual(this.securityService.openIdInitalValue, this.ngForm.form.value)) {
      this.security.dirtyCheckList.splice(this.security.dirtyCheckList.indexOf('openidProvider', 1));
    }

  }
  isProviderIdDisabled(providerId: string): boolean {
    return (this.securityService.isOpenIdProviderDisabled || providerId === 'custom' || providerId === 'google' || providerId === this.securityService.openId._selectModel);
  }
  override ngOnDestroy(): void {
    this.formChangesSubscription?.unsubscribe();
    this.resetFormSubscription?.unsubscribe();
    this.updateOpenIdProviderIdSubscription?.unsubscribe();
  }
}
